/**
 * AEAD can succeed while the sender signature fails (mutated metadata, v1
 * replay across conversations, substituted identity). Those bodies must not
 * render as normal trusted messages.
 */
export function isUnverifiedSignature(message: {
  signatureVerified?: boolean;
  deleted?: boolean;
}): boolean {
  return message.deleted !== true && message.signatureVerified === false;
}

/**
 * A pending row whose sender key fetch is still in flight. Callers still
 * treat it as unverified everywhere; only the banner copy differs.
 */
export function isSignatureCheckingActive(
  message: { signatureCheckingUntil?: number },
  now: number = Date.now()
): boolean {
  return message.signatureCheckingUntil != null && message.signatureCheckingUntil > now;
}
